import * as e from "react";
import { jsx as t } from "react/jsx-runtime";
import { EMPTY_SNAPSHOT as n } from "@fluentui/priority-overflow";
//#region src/shared/overflow/overflow-context.tsx
var r = () => void 0, i = {
	registerItem: () => r,
	registerOverflowMenu: () => r,
	registerDivider: () => r,
	updateOverflow: r,
	forceUpdateOverflow: r,
	containerRef: { current: null },
	getSnapshot: () => n,
	subscribe: () => r
}, a = e.createContext(null), o = ({ value: e, children: n }) => /* @__PURE__ */ t(a.Provider, {
	value: e,
	children: n
});
function s(t) {
	let n = e.useContext(a) ?? i;
	return t ? t(n) : n;
}
//#endregion
export { a as OverflowContext, o as OverflowProvider, s as useOverflowContext };
